// This file is automatically generated. DO NOT EDIT.

import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetInvitesResponse {
  invitedEmail: string;
  invitedRole: 'user' | 'member_lite';
  workspaceName: string | null;
  workspaceMembersCount: number;
  workspacePlanFeatures: 'basic' | 'pro' | 'registered' | 'enterprise';
}

export async function getInvitesResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetInvitesResponse>,
): Promise<GetInvitesResponse> {
  return getJSONResponse<GetInvitesResponse>(
    response,
    'getInvitesResponse',
    options,
  );
}
